import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const InventoryComponent = () => {
  return (
    <>
      <Helmet>
        <title>Inventory | Admin</title>
      </Helmet>
      <Outlet />
    </>
  );
};

export default InventoryComponent;
